import { BlogSection } from '@/types/blog';

export const zieldirektive: BlogSection = {
  id: 'zieldirektive',
  title: 'Die Zieldirektive: Der Nordstern meines Systems',
  content: `
    <p class="mb-4">
      Jedes gute Betriebssystem dient einem Zweck. Es optimiert Ressourcen, um ein definiertes Ziel zu erreichen. Bevor ich also auf einzelne Regeln eingehe, steht die eine Frage im Raum, die über allen anderen schwebt: <strong>Wofür das Ganze?</strong>
    </p>
    
    <p class="mb-6">
      Die Antwort ist meine Zieldirektive. Sie ist der Nordstern, der Kompass und der finale Checksum für jede wichtige Entscheidung. Sie ist kurz, nicht verhandelbar und lautet:
    </p>
    
    <blockquote class="border-l-4 border-joerg-600 pl-6 py-4 mb-6 bg-joerg-50 italic text-xl">
      Wirtschaftlicher, nachhaltiger Erfolg bei andauernder Gesundheit.
    </blockquote>
    
    <p class="mb-4">
      Jeder Teil dieser Direktive ist ein bewusst gesetzter Anker:
    </p>
    
    <ul class="list-none space-y-3 mb-4">
      <li class="pl-6 relative">
        <span class="absolute left-0 text-joerg-600">→</span>
        <strong>Wirtschaftlicher Erfolg:</strong> Die notwendige Basis.
      </li>
      <li class="pl-6 relative">
        <span class="absolute left-0 text-joerg-600">→</span>
        <strong>Nachhaltiger Erfolg:</strong> Der Fokus auf die lange Sicht, nicht auf kurzfristige Hacks.
      </li>
      <li class="pl-6 relative">
        <span class="absolute left-0 text-joerg-600">→</span>
        <strong>Bei andauernder Gesundheit:</strong> Die entscheidende, nicht verhandelbare Bedingung. Jeder Erfolg, der auf Kosten der Gesundheit erkauft wird, ist per Definition dieses Systems ein Misserfolg.
      </li>
    </ul>
    
    <p class="mb-4">
      Diese Direktive ist der Filter, durch den jede neue Idee, jedes Projekt und jede Anfrage laufen muss.
    </p>
  `
};
